import * as React from "react";
import { Route, Switch } from "react-router-dom";
import AboutComponent from "./components/about.component";
import ContactusComponent from "./components/contactus.component";
import MainComponent from "./components/main.component";
import PrivacyPolicyComponent from "./components/privacypolicy.component";
import TermsComponent from "./components/terms.component";

export default (
  <Switch>
    <Route path={process.env.PUBLIC_URL + "/about"} component={AboutComponent} />
    <Route path={process.env.PUBLIC_URL + "/terms"} component={TermsComponent} />
    <Route path={process.env.PUBLIC_URL + "/contactus"} component={ContactusComponent} />
    <Route path={process.env.PUBLIC_URL + "/privacy"} component={PrivacyPolicyComponent} />
    <Route component={MainComponent} />
  </Switch>
);



// WEBPACK FOOTER //
// ./src/Router.tsx